import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";
import { DASHBOARD_WIZARD } from "@/core/constants/layout";

const router = [
  {
    path: routes.refurbDiagnosisQuestions.path,
    name: routes.refurbDiagnosisQuestions.name,
    component: () =>
      import(
        /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbQuestionsList/RefurbQuestionsListPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE,
      routeKeyToPreventReloadMainLayout: routes.refurbDiagnosisQuestions.path,
    },
    props: (route) => ({
      alert: route.query.alert ? JSON.parse(route.query.alert) : null,
    }),
  },
  {
    path: routes.refurbQuestionEdit.path,
    name: routes.refurbQuestionEdit.name,
    component: () =>
      import(
        /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbQuestionConfig/RefurbQuestionConfigPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE,
    },
  },
  {
    path: routes.refurbQuestionCreate.path,
    name: routes.refurbQuestionCreate.name,
    component: () =>
      import(
        /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbQuestionConfig/RefurbQuestionConfigPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE,
    },
  },
  {
    path: routes.refurbDiagnosisStart.path,
    name: routes.refurbDiagnosisStart.name,
    component: () =>
      import(
        /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisStart/RefurbDiagnosisStartPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
    },
    props: true,
  },
  {
    path: routes.refurbDiagnosisProcessing.path,
    name: routes.refurbDiagnosisProcessing.name,
    component: (/* webpackChunkName: "refurb-diagnosis" */) =>
      import("@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisProcessing/RefurbDiagnosisProcessingPage.vue"),
    redirect: { name: routes.refurbDiagnosisQuestionsProcessing.name },
    meta: {
      permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
      layoutType: DASHBOARD_WIZARD,
      routeKeyToPreventReloadMainLayout: "diagnostic",
    },
    props: true,
    children: [
      {
        path: routes.refurbDiagnosisQuestionsProcessing.path,
        name: routes.refurbDiagnosisQuestionsProcessing.name,
        component: () =>
          import(
            /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisProcessing/Questions.vue"
          ),
        props: true,
        meta: {
          layoutType: DASHBOARD_WIZARD,
          permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
          routeKeyToPreventReloadMainLayout: "diagnostic",
        },
      },
      {
        path: routes.refurbDiagnosisSummary.path,
        name: routes.refurbDiagnosisSummary.name,
        component: () =>
          import(
            /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisProcessing/Summary.vue"
          ),
        props: true,
        meta: {
          layoutType: DASHBOARD_WIZARD,
          permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
          routeKeyToPreventReloadMainLayout: "diagnostic",
        },
      },
      {
        path: routes.refurbDiagnosisStock.path,
        name: routes.refurbDiagnosisStock.name,
        component: () =>
          import(
            /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisProcessing/StockChoice.vue"
          ),
        props: true,
        meta: {
          layoutType: DASHBOARD_WIZARD,
          permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
          routeKeyToPreventReloadMainLayout: "diagnostic",
        },
      },
      {
        path: routes.refurbDiagnosisFinalized.path,
        name: routes.refurbDiagnosisFinalized.name,
        component: () =>
          import(
            /* webpackChunkName: "refurb-diagnosis" */ "@/apps/dashboard/refurbDiagnosis/view/pages/refurbDiagnosisProcessing/Finalized.vue"
          ),
        props: true,
        meta: {
          layoutType: DASHBOARD_WIZARD,
          permission: userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE,
          routeKeyToPreventReloadMainLayout: "diagnostic",
        },
      },
    ],
  },
];

export default router;
